module.exports = __webpack_public_path__ + "static/img/p555.2a4c908.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/p555.jpg
// module id = V3sN
// module chunks = 1